import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      window.scrollTo(0, 0);
    };

    const animationFrame = requestAnimationFrame(handleScroll);

    return () => cancelAnimationFrame(animationFrame);
  }, [pathname]);
};

export default useScrollToTop;
